module.exports = __webpack_public_path__ + "media/images/by_w-6c4070e0b3b2551838992d0e7e059557.png";